'use strict';

var destroy = require('./plugin/destroy');
var initialize = require('./plugin/initialize');
var update = require('./plugin/update');

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};



//////////////////
// WEBPACK FOOTER
// ./~/perfect-scrollbar/src/js/main.js
// module id = 13
// module chunks = 0